export default __webpack_public_path__ + "static/media/ps4.6b07d316.png";